import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/admin/api";
import { useAuth } from "@/admin/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        // clean the hash and go to dashboard
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data.user } });
      } catch {
        navigate("/login?error=google");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-navy text-white">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-gold border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-6 overline text-gold">Signing you in…</p>
      </div>
    </div>
  );
}
